import axios from "axios";
import { Payout_Service } from "../Url";

export const pricingPartnerAction = {
  PAYOUT_LIST_DATA_SUCCESS: "PAYOUT_LIST_DATA_SUCCESS",
  PAYOUT_LIST_DATA_ERROR: "PAYOUT_LIST_DATA_ERROR",
};


export function payoutListDataSuccess(props) {
  const { accessToken, financialYear, approvalstageId } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url:`http://localhost:8301/partner-payout-service/reports/get/monthly?year=${financialYear}&approval_stage_id=${approvalstageId}`,
        url: `${Payout_Service}/reports/get/monthly?year=${financialYear}&approval_stage_id=${approvalstageId}`,
      });
      const data = response.data;
      dispatch({
        type: pricingPartnerAction.PAYOUT_LIST_DATA_SUCCESS,
        payload: data.data,
      });
      console.log("Payout List Data1:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: pricingPartnerAction.PAYOUT_LIST_DATA_ERROR,
        payload: error.message || "Failed to fetch payout list data",
      });
      return error;
    }
  };
}

export function GeneratePayoutFormonthAction(props) {
  const { accessToken, financialYear, month } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: `http://localhost:8301/partner-payout-service/reports/generate?month=${month}&year=${financialYear}`,
        url: `${Payout_Service}/reports/generate?month=${month}&year=${financialYear}`,
      });
      const data = response.data;
      console.log("Generate Payout Data:", data);

      // Refresh payout list after generating payout
      // await dispatch(
      //   payoutListDataSuccess({ accessToken, financialYear })
      // );

      return response;
    } catch (error) {
      console.error("Error:", error);
      return error;
    }
  };
}

export function submitReportForApprovalAction(props) {
  const { accessToken, financialYear, reportid, approvalStageId, remarksComment, remarkType} = props;
  // console.log("approval stage id:", appprovalStageId)
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: `http://localhost:8301/partner-payout-service/reports/submit-approval?approval_stage_id=${appprovalStageId}`,
        url: `${Payout_Service}/reports/submit-approval?approval_stage_id=${approvalStageId}`,
        data: {"reportId": reportid, "remarksComment": remarksComment, "remarkType": remarkType}
      });
      const data = response.data;
      console.log("Submit Report Data:", data);

      // Refresh payout list after submitting report
      await dispatch(
        payoutListDataSuccess({ accessToken, financialYear })
      );

      return data;
    } catch (error) {
      console.error("Error:", error);
      return error;
    }
  };
}

export function payoutListChanalwiseDataSuccess(props) {
  const { accessToken, financialYear, approvalStageId} = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: `http://localhost:8301/partner-payout-service/reports/regenerate?month=${month}&year=${financialYear}`,
        url: `${Payout_Service}/reports/payout-channel-monthly-report?year=${financialYear}&approvalStageId=${approvalStageId}`,
      });
      const data = response.data;
      console.log("Regenerate Payout Data:", data);

      // // Refresh payout list after regenerating payout
      // await dispatch(
      //   payoutListDataSuccess({ accessToken, financialYear })
      // );

      return data;
    } catch (error) {
      console.error("Error:", error);
      return error;
    }
  }
}
